import redirects from '~/data/redirects.json';
import { addEndTrailingSlash, removeEndTrailingSlash } from '~/utils/helpers';

export default ({ route, redirect, i18n }) => {
  const { path, query, hash } = route;
  const { localeCodes, defaultLocale } = i18n;
  const prefixedLocales = localeCodes.filter(i => i !== defaultLocale);
  const pathWithSlash = addEndTrailingSlash(path);
  const pathWithoutSlash = removeEndTrailingSlash(path);

  // ADD END TRAILING SLASH TO I18N PAGES
  if (prefixedLocales.some(i => path === `/${i}`)) {
    return redirect(302, {
      path: pathWithSlash,
      query,
      hash
    });
  }

  // REDIRECT TO INDEX PAGE
  if (pathWithoutSlash === '/home') {
    return redirect(302, {
      path: '/',
      query,
      hash
    });
  }
  if (pathWithoutSlash === '/en/home') {
    return redirect(302, {
      path: '/en/',
      query,
      hash
    });
  }

  // FROM-TO REDIRECTS
  const redirectRule = redirects.find(i => {
    const normalizeFrom = removeEndTrailingSlash(i.from);
    const isMatching = pathWithoutSlash === normalizeFrom;
    const isNotLoop =
      pathWithoutSlash !== i.to &&
      pathWithSlash !== i.to &&
      i.from !== i.to;
    return isMatching && isNotLoop;
  });
  if (redirectRule) {
    return redirect(redirectRule.code || 301, {
      path: redirectRule.to,
      query,
      hash
    });
  }
};
